export default {
  computed: {
    navTitle() {
      return 'standard'
    }
  },
  created() {
    //  console.log('create', this.navTitle)
    document.title = this.navTitle
  },
  activated() {
    //  console.log('activated', this.navTitle)
    document.title = this.navTitle
  },
  watch: {
    navTitle(val) {
      document.title = val
    }
  }
}
